/* Klivlo · La Poche Furtive
   Portage de reference/product-page-fr.html vers Shopify.

   Une différence de fond avec la maquette : là-bas le panier est simulé par un
   compteur local et la remise est calculée en JavaScript. Ici le tiroir lit
   /cart.js et affiche les totaux que Shopify a réellement calculés. C'est la
   seule façon de garantir ce que demande le brief — total du tiroir identique
   au total du checkout. Un total calculé côté client peut toujours mentir ;
   celui-ci est celui de la caisse par construction.

   Les trois comportements signalés comme fragiles sont repris tels quels :
   estimation de livraison, révélations au scroll, sélecteur de lot. */
(function () {
  'use strict';

  var root = document.querySelector('[data-pf-root]');
  var cfg = root ? root.dataset : {};

  /* Textes : réglages de la section (traduits par langue), le français en
     secours. Prix : langue + pays du visiteur, devise du panier. */
  var TXT = {
    save: 'Vous économisez <b style="font-weight:700;">[save]</b> · livraison suivie [ship] · retours 30 jours',
    nosave: 'Livraison suivie [ship] · retours 30 jours · colis assuré',
    shipToday: "expédition aujourd'hui avant [h] h", shipOn: 'expédition le [date]',
    dwLot: 'Lot de [n] · − [pct] % · [each] l’unité', dwUnit: '[each] l’unité',
    dwSave: 'Vous économisez <b style="font-weight:700;">[save]</b> · livraison suivie [ship]',
    dwNosave: 'Livraison suivie [ship] · retours 30 jours',
    up2: 'Ajoutez-en une seconde', up3: 'Passez à trois', upSub: 'Le lot de [n] revient à [each] l’unité.'
  };
  try {
    var custom = JSON.parse((document.getElementById('pf-text') || {}).textContent || '{}');
    Object.keys(custom).forEach(function (k) { if (custom[k]) TXT[k] = custom[k]; });
  } catch (e) {}
  function fill(s, m) { return Object.keys(m).reduce(function (a, k) { return a.split('[' + k + ']').join(m[k]); }, s || ''); }
  var LOCALE = cfg.pfLocale || 'fr-FR';
  var NF;
  try { NF = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: cfg.pfCurrency || 'EUR' }); }
  catch (e) { NF = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }); }
  function eu(cents) { return NF.format(cents / 100); }
  // [ship] = shipping price in the visitor's currency (snippets/pf-ship).
  var SHIP = parseInt(cfg.pfShip || '0', 10);
  if (SHIP) Object.keys(TXT).forEach(function (k) { TXT[k] = fill(TXT[k], { ship: eu(SHIP) }); });
  function el(id) { return document.getElementById(id); }

  /* ------------------------------------------------------------------ 1
     Estimation de livraison — horloge Europe/Paris, pas celle du visiteur.
     Cutoff paramétrable ; au-delà, ou le week-end, le colis part le jour
     ouvré suivant et la fenêtre glisse d'autant. Repris tel quel. */
  (function () {
    var M = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet',
             'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    var TZ = cfg.pfTz || 'Europe/Paris';
    var CUTOFF = parseInt(cfg.pfCutoff || '14', 10);
    var DMIN = parseInt(cfg.pfDelaiMin || '3', 10);
    var DMAX = parseInt(cfg.pfDelaiMax || '7', 10);

    function parisNow() {
      try {
        var p = {}, parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', hour12: false
        }).formatToParts(new Date());
        parts.forEach(function (x) { p[x.type] = x.value; });
        return new Date(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute);
      } catch (e) { return new Date(); }
    }
    var FR = /^fr/.test(LOCALE);
    var DF = null;
    try { DF = new Intl.DateTimeFormat(LOCALE, { day: 'numeric', month: 'long' }); } catch (e) {}
    function fr(d) {
      if (FR || !DF) { var n = d.getDate(); return (n === 1 ? '1er' : n) + ' ' + M[d.getMonth()]; }
      return DF.format(d);
    }
    function isWorkday(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
    function nextWorkday(d) { do { d.setDate(d.getDate() + 1); } while (!isWorkday(d)); return d; }

    var now = parisNow();
    var ship = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (!isWorkday(ship) || now.getHours() >= CUTOFF) ship = nextWorkday(ship);
    function eta(days) { var d = new Date(ship), n = 0; while (n < days) { nextWorkday(d); n++; } return fr(d); }

    var f = el('pf-eta-from'), t = el('pf-eta-to'), s = el('pf-eta-ship');
    if (f) f.textContent = eta(DMIN);
    if (t) t.textContent = eta(DMAX);
    if (s) {
      var sameDay = ship.getDate() === now.getDate() && ship.getMonth() === now.getMonth();
      s.textContent = sameDay ? fill(TXT.shipToday, { h: CUTOFF }) : fill(TXT.shipOn, { date: fr(ship) });
    }
  })();

  /* ------------------------------------------------------------------ 2
     Sélecteur de lot.

     Le « lot » pilote la QUANTITÉ d'un même article, pas une variante par lot.
     C'est ce qui permet à la remise par paliers de suivre le nombre total
     d'unités du panier, y compris quand le client appuie sur « + » dans le
     tiroir. Les prix du brief le confirment : 37,96 = 2 × 18,98 et
     56,94 = 3 × 18,98.

     Le prix principal ne bouge jamais : c'est le prix unitaire. */
  var UNIT = parseInt(cfg.pfUnit || '1898', 10);   // centimes
  var VARIANT = cfg.pfVariant || '';
  var selected = parseInt(cfg.pfDefautLot || '2', 10);

  function palier(n) { return n >= 3 ? 30 : n === 2 ? 20 : 0; }
  // Même arithmétique que Shopify : remise unitaire tronquée au centime,
  // puis multipliée. Arrondir sur le total donnerait un centime de moins
  // que la caisse.
  function remiseUnitaire(n) { return Math.floor(UNIT * palier(n) / 100); }
  function totalPour(n) { return (UNIT - remiseUnitaire(n)) * n; }

  function choisir(card) {
    document.querySelectorAll('.pf-lot').forEach(function (c) {
      c.classList.remove('is-sel');
      c.setAttribute('aria-checked', 'false');
    });
    card.classList.add('is-sel');
    card.setAttribute('aria-checked', 'true');

    var n = parseInt(card.dataset.n, 10);
    selected = n;

    var total = totalPour(n), plein = UNIT * n, economie = plein - total;
    var t = el('pf-cta-total'); if (t) t.textContent = eu(total);
    var bb = el('pf-bb-price'); if (bb) bb.textContent = eu(total);

    var line = el('pf-save-line');
    if (line) {
      line.innerHTML = economie > 0 ? fill(TXT.save, { save: eu(economie) }) : TXT.nosave;
    }
  }

  document.querySelectorAll('.pf-lot').forEach(function (card) {
    card.addEventListener('click', function () { choisir(card); });
    card.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); choisir(card); }
    });
  });
  var initial = document.querySelector('.pf-lot.is-sel') || document.querySelector('.pf-lot');
  if (initial) choisir(initial);

  /* ------------------------------------------------------------------ 3
     Galerie : la vignette remplace la photo principale. */
  document.querySelectorAll('[data-pf-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      var main = document.querySelector('.pf-main');
      if (!main) return;
      main.src = b.dataset.full;
      main.srcset = b.dataset.fullset || '';
      document.querySelectorAll('[data-pf-thumb]').forEach(function (o) { o.removeAttribute('aria-current'); });
      b.setAttribute('aria-current', 'true');
    });
  });

  /* ------------------------------------------------------------------ 4
     Tiroir panier, sur le vrai panier Shopify. */
  var drawer = el('pf-drawer'), scrim = el('pf-scrim');

  function ouvrir(v) {
    if (!drawer || !scrim) return;
    scrim.classList.toggle('on', v);
    drawer.classList.toggle('on', v);
    document.body.style.overflow = v ? 'hidden' : '';
  }

  function getCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function unitesDuProduit(cart) {
    var n = 0;
    cart.items.forEach(function (it) {
      if (String(it.variant_id) === String(VARIANT)) n += it.quantity;
    });
    return n;
  }

  function peindre(cart) {
    var units = unitesDuProduit(cart);
    document.querySelectorAll('[data-pf-count]').forEach(function (o) { o.textContent = '(' + cart.item_count + ')'; });

    var vide = el('pf-dw-empty'), ligne = el('pf-dw-line');
    if (vide) vide.style.display = cart.item_count ? 'none' : 'block';
    if (ligne) ligne.style.display = cart.item_count ? 'grid' : 'none';

    var sub = el('pf-dw-subtotal'), save = el('pf-dw-save');
    if (!cart.item_count) {
      if (el('pf-dw-upsell')) el('pf-dw-upsell').style.display = 'none';
      if (sub) sub.textContent = eu(0);
      if (save) save.textContent = TXT.dwNosave;
      return;
    }

    var item = null;
    cart.items.forEach(function (it) { if (String(it.variant_id) === String(VARIANT)) item = it; });

    if (item) {
      var p = palier(units);
      var unitaire = Math.round(item.final_line_price / item.quantity);
      if (el('pf-dw-variant')) {
        el('pf-dw-variant').textContent = p
          ? fill(TXT.dwLot, { n: units, pct: p, each: eu(unitaire) })
          : fill(TXT.dwUnit, { each: eu(UNIT) });
      }
      if (el('pf-dw-qty')) el('pf-dw-qty').textContent = item.quantity;
      if (el('pf-dw-total')) el('pf-dw-total').textContent = eu(item.final_line_price);
      if (el('pf-dw-cmp')) {
        el('pf-dw-cmp').textContent = item.original_line_price > item.final_line_price
          ? eu(item.original_line_price) : '';
      }
      if (el('pf-dw-remove')) el('pf-dw-remove').dataset.key = item.key;
      document.querySelectorAll('[data-pf-dq]').forEach(function (b) { b.dataset.key = item.key; });
    }

    /* Ces deux lignes viennent de Shopify, pas d'un calcul local : c'est ce que
       la caisse facturera. */
    if (sub) sub.textContent = eu(cart.total_price);
    var economie = cart.original_total_price - cart.total_price;
    if (save) {
      save.innerHTML = economie > 0 ? fill(TXT.dwSave, { save: eu(economie) }) : TXT.dwNosave;
    }

    /* Relance vers le palier suivant : 1 → 2, 2 → 3. Rien au-delà. */
    var next = units === 1 ? 2 : units === 2 ? 3 : 0;
    var up = el('pf-dw-upsell');
    if (up) up.style.display = next ? 'flex' : 'none';
    if (next) {
      var delta = totalPour(next) - totalPour(units);
      if (el('pf-dw-up-title')) el('pf-dw-up-title').textContent = next === 2 ? TXT.up2 : TXT.up3;
      if (el('pf-dw-up-sub')) el('pf-dw-up-sub').textContent = fill(TXT.upSub, { n: next, each: eu(Math.round(totalPour(next) / next)) });
      if (el('pf-dw-up-cta')) {
        el('pf-dw-up-cta').innerHTML = '+ ' + eu(delta) + ' &nbsp;− ' + palier(next) + ' %';
        el('pf-dw-up-cta').dataset.to = next;
      }
    }
  }

  function rafraichir() { return getCart().then(peindre); }

  function changerLigne(key, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(peindre);
  }

  function ajouter(qty) {
    if (!VARIANT) return;
    var btn = el('pf-cta-btn');
    if (btn) btn.disabled = true;
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(VARIANT), quantity: qty }] })
    })
      .then(function (r) { return r.json(); })
      .then(rafraichir)
      .then(function () { ouvrir(true); })
      .catch(function (e) { console.error(e); })
      .finally(function () { if (btn) btn.disabled = false; });
  }

  document.querySelectorAll('[data-pf-add]').forEach(function (b) {
    b.addEventListener('click', function () {
      var v = b.dataset.pfAdd;
      ajouter(v === 'selected' ? selected : parseInt(v, 10));
    });
  });
  document.querySelectorAll('[data-pf-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); rafraichir().then(function () { ouvrir(true); }); });
  });
  document.querySelectorAll('[data-pf-close]').forEach(function (b) {
    b.addEventListener('click', function () { ouvrir(false); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') ouvrir(false); });

  document.querySelectorAll('[data-pf-dq]').forEach(function (b) {
    b.addEventListener('click', function () {
      var key = b.dataset.key;
      if (!key) return;
      var out = el('pf-dw-qty');
      var q = Math.max(0, parseInt(out ? out.textContent : '0', 10) + parseInt(b.dataset.pfDq, 10));
      changerLigne(key, q);
    });
  });
  var rm = el('pf-dw-remove');
  if (rm) rm.addEventListener('click', function () { if (rm.dataset.key) changerLigne(rm.dataset.key, 0); });
  var upcta = el('pf-dw-up-cta');
  if (upcta) {
    upcta.addEventListener('click', function () {
      var key = (el('pf-dw-remove') || {}).dataset ? el('pf-dw-remove').dataset.key : null;
      if (key) changerLigne(key, parseInt(this.dataset.to, 10));
    });
  }

  if (drawer) rafraichir();

  /* ------------------------------------------------------------------ 5
     Révélations, progression, barre collante : une seule boucle rAF.

     L'état de repos est VISIBLE. On n'arme l'animation qu'à l'intérieur du
     premier rAF, donc seulement si la boucle tourne vraiment, et un filet de
     sécurité à 4 s force l'affichage. Ne pas « simplifier » en armant depuis le
     CSS avec un IntersectionObserver : c'est ce qui laissait le contenu
     invisible quand la boucle ne démarrait pas. */
  var bar = el('pf-progress'), buybar = el('pf-buybar');

  requestAnimationFrame(function () {
    document.querySelectorAll('[data-pf-reveal]').forEach(function (e) {
      if (e.getBoundingClientRect().top > innerHeight * 0.9) e.classList.add('pf-armed');
    });
    tick();
  });
  setTimeout(function () {
    document.querySelectorAll('[data-pf-reveal].pf-armed').forEach(function (e) { e.classList.add('pf-in'); });
  }, 4000);

  function tick() {
    var top = window.scrollY || document.documentElement.scrollTop;
    var max = document.documentElement.scrollHeight - innerHeight;
    if (bar) bar.style.width = (max > 0 ? Math.min(top / max * 100, 100) : 0) + '%';
    if (buybar) buybar.style.display = top > 700 ? 'flex' : 'none';
    document.querySelectorAll('[data-pf-reveal].pf-armed:not(.pf-in)').forEach(function (e) {
      if (e.getBoundingClientRect().top < innerHeight * 0.88) e.classList.add('pf-in');
    });
    requestAnimationFrame(tick);
  }
})();
